import React from "react";
import { Plus } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectSeparator, SelectTrigger, SelectValue } from "../../shadcn/select";
import { cn } from "../../shadcn/lib/utils";

const Dropdown = ({
  options = [],
  value,
  onValueChange,
  placeholder = "Select an option",
  disabled = false,
  className,
  size = "default",
  contentClassName,
  bottomActionLabel,
  onBottomAction,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  return (
    <Select
      value={value}
      onValueChange={onValueChange}
      disabled={disabled}
      open={open}
      onOpenChange={(v) => {
        setOpen(v);
        if (props.onOpenChange) props.onOpenChange(v);
      }}
      {...props}
    >
      <SelectTrigger
        className={cn("w-full", className)}
        size={size}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent
        className={cn(
          // Force solid white background (even in dark mode)
          "bg-white z-[1000]",
          contentClassName
        )}
      >
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </SelectItem>
        ))}
        {onBottomAction && (
          <>
            <SelectSeparator className="my-2" />
            <div className="px-[14px] mb-4">
                <button
                  type="button"
                  onClick={() => {
                    setOpen(false);
                    onBottomAction();
                  }}
                  className={cn(
                    // Layout: full width, 40px height
                    "w-full h-10",
                    // Visuals: 8px radius, 1px border brand/50, brand/50 bg
                    "rounded-lg border border-brand-50 bg-brand-50",
                    // Content: spacing and typography (14px, 20px line-height, semibold)
                    "px-4 py-[10px] gap-2 text-sm leading-5 font-semibold text-brand-700 flex items-center justify-center",
                    // Subtle shadow
                    "shadow-[0_1px_2px_rgba(10,13,18,0.05)] hover:opacity-95 outline-none focus:outline-none focus-visible:outline-none ring-0 focus:ring-0",
                  )}
                >
                  <Plus className="size-5 text-brand-700" />
                  {bottomActionLabel || "Add New"}
                </button>
            </div>
          </>
        )}
      </SelectContent>
    </Select>
  );
};

export default Dropdown;
